import { createTheme } from "@mui/material/styles";
import { darkPalette } from "./palette";
import { buildComponents } from "./components";
import { buildShadows } from "./shadows";
import { typography, fontMono } from "./typography";

const darkTheme = createTheme({
  palette: darkPalette,
  typography,
  shape: { borderRadius: 12 },
  shadows: buildShadows("dark"),
  components: buildComponents(darkPalette),
  custom: { fontMono },
});

export default darkTheme;
